import React, { createContext, useContext } from 'react';

import { useDrawerStack } from '../hooks';

const SendoutsDrawerStackContext = createContext(null);

export const SendoutsDrawerStackProvider = ({ children }) => {
  const drawerStack = useDrawerStack();

  return (
    <SendoutsDrawerStackContext.Provider value={drawerStack}>
      {children}
    </SendoutsDrawerStackContext.Provider>
  );
};

export const useSendoutsDrawerStack = () => {
  const context = useContext(SendoutsDrawerStackContext);
  if (!context) {
    throw new Error('useSendoutsDrawerStack must be used within SendoutsDrawerStackProvider');
  }
  return context;
};
